import React, { useContext, useState } from 'react'
import { EPCRContext } from './EPCR'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import DeleteIcon from '@mui/icons-material/Delete'
import API from '../../../services/API'

const DeletePopup = ({ open, onClose, epcrID, onDeleted }) => {
  const [deleteConfirmText, setDeleteConfirmText] = useState('')

  const handleDelete = (e) => {
    e.preventDefault()
    API.post('/delete-epcr/' + epcrID, {
      action: 'HARD_DELETE',
      reason: 'Early ePCR. No patient details added yet.',
    }).then((res) => {
      if (res.status === 200) {
        if (onDeleted) {
          onDeleted()
        } else {
          window.location.reload()
        }
      }
    })
  }
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose()
        setDeleteConfirmText('')
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '20rem',
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          borderColor: 'none',
          maxHeight: 500,
          overflow: 'auto',
          padding: 1,
          outline: 'none',
        }}
      >
        <Stack
          gap={1}
          component="form"
          onSubmit={handleDelete}
          alignItems="center"
        >
          <Typography variant="title2">Are you Sure?</Typography>
          <Typography variant="caption">
            Deleting this ePCR cannot be undone.
          </Typography>
          <Typography>
            Type '<i>Delete</i>' into the box below to confirm.
          </Typography>
          <TextField
            name="confirmDelete"
            fullWidth
            placeholder="Delete"
            value={deleteConfirmText}
            onChange={(e) => setDeleteConfirmText(e.target.value)}
            autoComplete="off"
          />
          <Button
            type="submit"
            disabled={deleteConfirmText.toLowerCase() !== 'delete'}
            startIcon={<DeleteIcon />}
            color="error"
            fullWidth
          >
            Delete
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default DeletePopup
